import { render, staticRenderFns } from "./CreateZipformTransaction.vue?vue&type=template&id=8c88fb72&scoped=true&lang=pug"
import script from "./CreateZipformTransaction.vue?vue&type=script&lang=js"
export * from "./CreateZipformTransaction.vue?vue&type=script&lang=js"
import style0 from "./CreateZipformTransaction.vue?vue&type=style&index=0&id=8c88fb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c88fb72",
  null
  
)

export default component.exports